/** Мок-данные проектов для шага «Получатели», пока нет API */

export const ALLOCATION_ROLES = {
  recipient: { label: "Получатель", selectable: true },
  excluded: { label: "Исключён", selectable: false },
};

const BASE_PROJECTS = [
  {
    code: "505-1",
    name: "ОД_505-1_Б_ЗД_МЖК_Capitalpark7BComfort_0_2025_0",
    department: "РП МЖК",
    projectType: "Рабочий проект",
    buildingType: "Многоквартирный жилой комплекс",
    customer: "Capital Park ТОО",
    startDate: "01.03.2025",
    endDate: "31.12.2026",
  },
  {
    code: "429-4",
    name: "ОД_429-4_Б_ЗД_МЖК_Aisar4очередь_FamilyVillageNSTOO_2025_0",
    department: "РП МЖК",
    projectType: "Рабочий проект",
    buildingType: "Многоквартирный жилой комплекс",
    customer: "FamilyVillage NS ТОО",
    startDate: "15.02.2025",
    endDate: "30.09.2026",
  },
  {
    code: "455-2",
    name: "ОД_455-2_Б_АН_МЖК_УлыдалаComfort12очередь_BIKidsGardenTOO_2025",
    department: "РП МЖК",
    projectType: "Авторский надзор",
    buildingType: "Многоквартирный жилой комплекс",
    customer: "BI Kids Garden ТОО",
    startDate: "01.06.2025",
    endDate: "31.05.2027",
  },
  {
    code: "514-1",
    name: "ОД_514-1_Б_ЗД_МЖК_МЖКОIUУчасток6_Цесинстрой_2025",
    department: "РП МЖК",
    projectType: "Эскизный проект",
    buildingType: "Многоквартирный жилой комплекс",
    customer: "Цесинстрой ТОО",
    startDate: "10.09.2025",
    endDate: "31.03.2026",
  },
  {
    code: "320-2",
    name: "ОД_320-2_А_ЗД_ЖК_Riverside_Очередь2_BIGroup_2025",
    department: "РП МЖК",
    projectType: "BIM-моделирование",
    buildingType: "Многоквартирный жилой комплекс",
    customer: "BI Group ТОО",
    startDate: "01.01.2025",
    endDate: "31.12.2025",
  },
  {
    code: "118-1",
    name: "ОД_118-1_В_ЗД_БЦ_AlmaTower_Блок1_Базис_2025",
    department: "РП ГЗ",
    projectType: "Рабочий проект",
    buildingType: "Бизнес-центр",
    customer: "Базис-А ТОО",
    startDate: "01.04.2025",
    endDate: "31.08.2026",
  },
  {
    code: "402-3",
    name: "ОД_402-3_Б_ЗД_ШК_Школа1200_Косшы_2026",
    department: "РП ГЗ",
    projectType: "Рабочий проект",
    buildingType: "Школа",
    customer: "ГУ «Отдел строительства г. Косшы»",
    startDate: "01.02.2026",
    endDate: "30.11.2026",
  },
  {
    code: "377-1",
    name: "ОД_377-1_Б_ЗД_ДС_Детсад320_Астана_2026",
    department: "РП ГЗ",
    projectType: "Эскизный проект",
    buildingType: "Детский сад",
    customer: "ГУ «Управление строительства г. Астаны»",
    startDate: "15.03.2026",
    endDate: "15.10.2026",
  },
  {
    code: "261-2",
    name: "ОД_261-2_А_АН_АЗ_АдмЗдание_Акимат_2025",
    department: "РП ГЗ",
    projectType: "Авторский надзор",
    buildingType: "Административное здание",
    customer: "ГУ «Управление строительства г. Астаны»",
    startDate: "01.07.2025",
    endDate: "30.06.2026",
  },
  {
    code: "533-1",
    name: "ОД_533-1_Б_ЗД_ПЗ_Склад_KazLogistic_2026",
    department: "РП ПЗ",
    projectType: "Рабочий проект",
    buildingType: "Производственное здание",
    customer: "KazLogistic ТОО",
    startDate: "01.01.2026",
    endDate: "31.12.2026",
  },
  {
    code: "541-1",
    name: "ОД_541-1_Б_BIM_ПЗ_Завод_КазСтальГрупп_2026",
    department: "РП ПЗ",
    projectType: "BIM-моделирование",
    buildingType: "Производственное здание",
    customer: "КазСтальГрупп ТОО",
    startDate: "01.05.2026",
    endDate: "31.03.2027",
  },
  {
    code: "466-2",
    name: "ОД_466-2_Б_ЗД_МЖК_GreenQuarter_BIGroup_2026",
    department: "РП МЖК",
    projectType: "Рабочий проект",
    buildingType: "Многоквартирный жилой комплекс",
    customer: "BI Group ТОО",
    startDate: "01.02.2026",
    endDate: "28.02.2027",
  },
];

/** Проекты, исключённые из распределения: в списке видны, но выбрать их нельзя */
const EXCLUDED_CODES = new Set(["320-2", "261-2"]);

export const RECIPIENT_PROJECTS = BASE_PROJECTS.map((project, index) => ({
  ...project,
  id: index + 1,
  code: `ОД_${project.code}`,
  role: EXCLUDED_CODES.has(project.code) ? "excluded" : "recipient",
}));

const uniqueValues = (key) =>
  [...new Set(RECIPIENT_PROJECTS.map((project) => project[key]))].sort((a, b) =>
    a.localeCompare(b, "ru")
  );

export const DEPARTMENT_OPTIONS = uniqueValues("department");
export const PROJECT_TYPE_OPTIONS = uniqueValues("projectType");
export const BUILDING_TYPE_OPTIONS = uniqueValues("buildingType");
export const CUSTOMER_OPTIONS = uniqueValues("customer");
